export class DataMovementsSce {
    projectId: any;
    documentNum: any;
    documentType: any;
    numberPag: any;
    recordsNum: any;
    surrogacyFilter: any;
    startDate: any;
    endDate:any;
}